module.exports = __webpack_public_path__ + "static/media/va_desc2.6aaed9f7.png";